var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 11.9733C20.9999 11.4213 21.4479 10.9733 21.9999 10.9733C22.5519 10.9733 22.9999 11.4213 22.9999 11.9733V12.9043C22.9969 17.7763 19.7909 22.0653 15.1189 23.4463C10.4469 24.8273 5.42389 22.9713 2.77189 18.8843C0.120886 14.7973 0.472886 9.45327 3.63789 5.75027C6.80289 2.04727 12.0269 0.866272 16.4769 2.84927C16.9809 3.07427 17.2079 3.66527 16.9829 4.16927C16.7579 4.67327 16.1669 4.90027 15.6629 4.67527C12.0219 3.05327 7.74789 4.01827 5.15789 7.04827C2.56789 10.0783 2.27989 14.4503 4.44889 17.7943C6.61789 21.1383 10.7289 22.6563 14.5509 21.5263C18.3729 20.3963 20.9969 16.8863 20.9989 12.9013V11.9713L20.9999 11.9733ZM11.9999 13.4893L22.2929 3.19627C22.6839 2.80527 23.3169 2.80527 23.7069 3.19627C24.0969 3.58727 24.0979 4.22027 23.7069 4.61027L12.7069 15.6103C12.3159 16.0013 11.6829 16.0013 11.2929 15.6103L8.29289 12.6103C7.90189 12.2193 7.90189 11.5863 8.29289 11.1963C8.68389 10.8063 9.31689 10.8053 9.70689 11.1963L11.9999 13.4893Z",
    fill: "#6BA342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.54668c9fbb21ddaff8d375ed12fb74fb.svg";
export { ForwardRef as ReactComponent };